<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{ $t('Void-List') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarihi" v-model="Rapor.BaslangicTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarihi" v-model="Rapor.BitisTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout align-center="">
                          <div v-if="load1">
                            <v-btn color="info" @click="getList(1,kayitadet,siralamatipi)" fab small="" dark>

                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-layout row="" wrap v-if="listegorunum">

                  <v-flex v-show="kayitvarmi" xs12 sm12 md12>
                    <v-card flat="" color="grey lighten-5">
                      <v-flex xs12 sm12 md12>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md9>
                            <v-layout align-center="" fill-height="">
                              <div class=" font-weight-large grey--text title ">
                                Toplam &nbsp; {{recordcount}}&nbsp; kayıt listelendi.
                              </div>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md2>
                            <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1"
                              v-model="siralamatipi" item-text="text" item-value="value" :label="$t('Sort-By')">
                            </v-select>
                          </v-flex>
                          <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                            <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet"
                              item-text="text" item-value="value" label="Göster"></v-select>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex pa-2 v-for="item in voidlist" v-bind:key="item.id" xs12 sm12 md12>
                        <v-hover>
                          <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
                            <v-list two-line="">
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-card flat class="black--text">
                                    <v-card flat="">
                                      <v-card-actions>
                                        <v-layout row wrap>

                                          <v-flex sm12 md1>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-img :src="getImgUrl(item.BiletBilgi.HavayoluKodu)" height="100%"
                                                    width="100%" contain>
                                                  </v-img>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-flex>

                                          <v-flex xs12 sm4 md2>
                                            <v-layout align-start justify-start row fill-height>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout row align-center justify-start>
                                                      <v-chip color="yellow" text-color="black">
                                                        {{$t('Voided-Ticket')}} 
                                                      </v-chip>

                                                    </v-layout>
                                                    <v-list-tile-sub-title>
                                                      &nbsp;<span class='grey-text--primary caption '>
                                                        {{item.BiletBilgi.HavayoluKodu}}
                                                        -
                                                        {{item.BiletBilgi.BiletNo}}
                                                        -
                                                        {{item.BiletBilgi.UcusTipi}}
                                                      </span>
                                                    </v-list-tile-sub-title>

                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>


                                          <v-flex xs12 sm4 md2>
                                            <v-layout align-start justify-start row fill-height>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout row wrap align-center="" justify-center>
                                                      <v-list-tile-title>

                                                        <div class="font-weight-bold grey--text subheading">
                                                          {{item.YolcuAdi}}
                                                        </div>
                                                      </v-list-tile-title>

                                                      <v-list-tile-sub-title>
                                                        <div class="font-weight-thin grey--text body-1 ">

                                                          {{item.CariKod}}

                                                        </div>
                                                      </v-list-tile-sub-title>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>


                                          <v-flex xs12 sm4 md2>
                                            <v-layout align-start justify-start row fill-height>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout row wrap align-center="" justify-center>
                                                      <v-list-tile-title>
                                                        <div class="font-weight-large red--text title">
                                                          {{item.TarihBilgi.IptalTarihi | dateformat}}
                                                        </div>
                                                      </v-list-tile-title>

                                                      <v-list-tile-sub-title>
                                                        <div class="font-weight-large grey--text caption ">
                                                          {{ $t('Sales-Date') }} :<span class="font-weight-large grey--text caption">
                                                            {{item.TarihBilgi.SatisTarihi | dateformat}}
                                                          </span>
                                                        </div>
                                                      </v-list-tile-sub-title>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex class="hidden-md-and-up" xs2 sm2 md2>
                                          </v-flex>
                                          <v-flex xs12 sm4 md2>
                                            <v-layout>

                                              <v-flex xs12 sm6 md6>
                                                <v-layout align-start="" justify-start fill-height>
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-list-tile-sub-title>
                                                          <div class="font-weight caption ">
                                                            {{ $t('Ticket-Amount') }} :
                                                          </div>
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-sub-title>
                                                          <div class="font-weight caption ">
                                                            {{$t('Taxes')}}:
                                                          </div>
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-sub-title>
                                                          <div class="font-weight caption ">
                                                            &nbsp;
                                                          </div>
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-sub-title>
                                                          <div class="font-weight caption ">

                                                          </div>
                                                        </v-list-tile-sub-title>

                                                      </v-list-tile-content>
                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm6 md6>
                                                <v-layout row justify-end="" fill-height>
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-list-tile-sub-title>
                                                          <v-layout align-center="" justify-end>
                                                            <div class="font-weight caption ">
                                                              {{item.BiletTutar | moneyformat}}{{getparabirimi()}}
                                                            </div>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-sub-title>
                                                          <v-layout align-center="" justify-end="">
                                                            <div class="font-weight caption ">
                                                              {{item.VergiTutar | moneyformat}}{{getparabirimi()}}

                                                            </div>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-sub-title>
                                                          <v-layout align-center="" justify-end="">
                                                            <div class="font-weight caption ">
                                                              &nbsp;
                                                            </div>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-sub-title>
                                                          <v-layout align-center="">
                                                            <div class="font-weight caption ">

                                                            </div>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-list-tile-content>
                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm4 md2>
                                            <v-layout row align-center justify-center="" fill-height="">
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout row wrap justify-center="">
                                                      <v-list-tile-title>
                                                        <v-layout row wrap justify-center="">
                                                          {{$t('Net-Amount')}}
                                                        </v-layout>
                                                      </v-list-tile-title>
                                                      <v-list-tile-sub-title>
                                                        <v-layout row wrap justify-center="">
                                                          <div class="red--text title">
                                                            {{item.NetTutar | moneyformat}}{{getparabirimi()}}
                                                          </div>
                                                        </v-layout>

                                                      </v-list-tile-sub-title>

                                                    </v-layout>
                                                  </v-list-tile-content>

                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex sm4 md1>
                                            <v-layout row align-center justify-end="">
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-action>
                                                    <v-layout align-center="" fill-height="" justify-end>





                                                      <a target="_blank"
                                                        v-bind:href="'#/bilet/yeni/id?' + 'isl=voidget&hyolukod='  + item.BiletBilgi.HavayoluKodu + '&biletno=' + item.BiletBilgi.BiletNo + '&ucustipi=' + item.BiletBilgi.UcusTipi">
                                                        <v-btn icon>
                                                          <v-icon x-large="" color="grey">
                                                            search
                                                          </v-icon>
                                                        </v-btn>
                                                      </a>

                                                    </v-layout>
                                                  </v-list-tile-action>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                      </v-card-actions>
                                    </v-card>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </v-list>
                          </v-card>
                        </v-hover>
                      </v-flex>



                    </v-card>
                  </v-flex>
                </v-layout>

              </v-layout>
            </v-form>
          </v-container>


          <v-container v-if="kayitvarmi" fluid="">

            <v-flex xs12 sm12 md12>
              <v-layout row fill-height="" justify-center>
                <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
              </v-layout>
            </v-flex>

          </v-container>


          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                              <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>


                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" ref="ara" v-model="Rapor.BiletNo" mask="##########"
                                :label="$t('Ticket-No')">
                              </v-text-field>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import logoo from '../../../assets/control'
  import helpers from "@/components/app/customcomp/helpers.js"
  import parainput from "@/components/app/customcomp/parainput.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        sayfalama: 1,
        pagenumber: 1,
        listegorunum: true,
        recordcount: null,
        kayitvarmi: false,
        kayitadet: 50,
        voidlist: [],
        siralamatipi: 'SalesDate',
        kayitsayisivmodel: 50,
        kayitsayisi: [{
          text: '50',
          value: 50
        }, {
          text: '100',
          value: 100
        }],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        ToplamAdet: 0,
        GenelDipToplam: 0,
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        Rapor: {
          HavaYoluKodu: null,
          BiletNo: null,
          SirketKodu: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'SalesDate',
          }
        },
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: '',
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsbs: [],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
     beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      parainput,
      havayollaricomp,
      yetkidialog
    },
    watch: {
      'siralamatipi': function (valuetip) {
        this.getList(this.sayfalama, this.kayitadet, valuetip)
      },
      'kayitadet': function (valueveriadet) {
        this.getList(1, valueveriadet, this.siralamatipi)
        this.sayfalama = 1
      },
      sayfalama(value) {
        this.getList(value, this.kayitadet, this.siralamatipi)
      },
    },
    methods: {
          getparabirimi() {
        return helpers.getparabirimi()
      },
      getImgUrl(img) {
        return logoo.logoControl(img);
      },
      git(v) {


        var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.BiletBilgi.HavayoluKodu + '&biletno=' + v.BiletBilgi
          .BiletNo + '&ucustipi=' + v.BiletBilgi.UcusTipi
        window.open(url, '_blank')
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
    computed:{
        siralamatipiitems(){
          return[{
          text: this.$t('Date-Ascending'),
          value: 'SalesDate'
        }, {
          text: this.$t('Date-Descending'),
          value: 'SalesDateDesc'
        }, {
          text: this.$t('Ticket-No-Increasing'),
          value: 'TicketNumber'
        }, {
          text: this.$t('Ticket-No-Decreasing'),
          value: 'TicketNumberDesc'
        }, {
          text: this.$t('Invoice-Date-Ascending'),
          value: 'InvoiceDate'
        }, {
          text: this.$t('Invoice-Date-Descending'),
          value: 'InvoiceDateDesc'
        }, {
          text: this.$t('Current-Code-Increasing'),
          value: 'CustomerCode'
        }, {
          text: this.$t('Current-Code-Decreasing'),
          value: 'CustomerCodeDesc'
        }, {
          text: this.$t('Price-Ascending'),
          value: 'Price'
        }, {
          text: this.$t('Price-Descending'),
          value: 'PriceDesc'
        }]
        },

        headersbs(){
          return [{
            text: this.$t('Code'),
            value: 'CariKod',
          },
          {
            text: this.$t('Ticket-No'),
            value: 'BiletBilgi.BiletNo ',
          },
          {
            text: this.$t('Airline-Code'),
            value: 'BiletBilgi.HavayoluKodu',
          },
          {
            text: this.$t('Internal-External'),
            value: 'BiletBilgi.UcusTipi',
          },
          {
            text: this.$t('Name-of-Passenger'),
            value: 'YolcuAdi',
          },
          {
            text: this.$t('Cancellation-Date'),
            value: 'TarihBilgi.IptalTarihi',
          },
          {
            text: this.$t('Sales-Date'),
            value: 'TarihBilgi.SatisTarihi',
          },
          {
            text: this.$t('Date-of-Ticket-Issue'),
            value: 'TarihBilgi.KesimTarihi',
          },
          {
            text: this.$t('Amount'),
            value: 'BiletTutar',
          },
          {
            text: this.$t('Tax-v2'),
            value: 'VergiTutar',
          },
          {
            text: this.$t('Discount'),
            value: 'IskontoTutar',
          }
        ]
      },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

  }



  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.sayfalama = 1
    this.getList(1, this.kayitadet, this.siralamatipi)

  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.havayolubil.havayolukodu = null,
      this.Rapor.HavaYoluKodu = null
    this.Rapor.BiletNo = null
    this.tumsirketler = false
    this.getList(1, this.kayitadet, this.siralamatipi)
    this.sayfalama = 1

  }


  function getList(sayfano, adet, siralatip) {


    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.Paging.SayfaNo = sayfano
        this.Rapor.Paging.VeriAdet = adet
        this.Rapor.Paging.SiralamaTip = siralatip

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Ticket/VoidReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.length > 0) {
            this.kayitvarmi = true
            this.pagenumber = response.body[0].TotalPage
            this.recordcount = response.body[0].TotalCount

          } else {
            this.kayitvarmi = false

          }

          this.voidlist = response.body

          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.kayitvarmi = false
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.kayitvarmi = false
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Ticket/VoidReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "VoidRaporu.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Ticket/VoidReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "VoidRaporu.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function beforeMount() {

  }
</script>
<style>
</style>